/** Server-safe vendor SEO score inputs (mirrors dashboard checklist). */
export type VendorSeoScoreInput = {
  description?: string | null;
  pickupParish?: string | null;
  logoUrl?: string | null;
  phone?: string | null;
  serviceAreas?: string[] | null;
  ratingCount?: number;
  hasOpeningHours?: boolean;
  /** At least one published product with 3+ images and complete alts (best-effort on server). */
  hasProductImageAltCredit?: boolean;
};

export function computeVendorSeoScoreCore(input: VendorSeoScoreInput): number {
  const desc = (input.description ?? '').toLowerCase();
  const parish = (input.pickupParish ?? '').toLowerCase();
  const offerings = desc.split(/[,;]/).filter((s) => s.trim().length > 3);

  const checks = [
    Boolean(parish && desc.includes(parish)),
    desc.includes('grenada'),
    offerings.length >= 3,
    Boolean(input.logoUrl?.trim()),
    Boolean(input.hasProductImageAltCredit),
    Boolean(input.serviceAreas?.length) || Boolean(input.hasOpeningHours),
    Boolean(input.phone?.trim()),
    (input.ratingCount ?? 0) > 0,
  ];

  const done = checks.filter(Boolean).length;
  return Math.round((done / checks.length) * 100);
}

/** Minimum score before self-serve onboarding submit is accepted (trusted partners exempt). */
export const VENDOR_SEO_SUBMIT_MIN_SCORE = 60;
